

/**
 * Ready Generale
 */
jQuery(document).ready(function ($) {
    $('#table-lista-prenotazione-annunci').DataTable({
        responsive: true,
        "oLanguage": {
            "sLengthMenu": "Mostra _MENU_ risultati per pagina",
            "sZeroRecords": "Nessun utente prenotato trovato",
            "sInfo": "Visualizzati Oggetti da _START_ a _END_ di _TOTAL_ risultati",
            "sInfoEmpty": "Mostra 0 su 0 di 0 risultati",
            "sInfoFiltered": "(Filtrati da _MAX_ risultati totali)",
            "sSearch": "Filtra:",
            "oPaginate": {
                "sFirst": "|<",
                "sLast": ">|",
                "sNext": ">",
                "sPrevious": "<"
            }
        }
        
    });
/*
 * 
 * @type Boolean|Boolean
 * responsive: true,
        "fnDrawCallback": reinizializzaTooltips,
        "columns": [
            {"data": "Foto"},
            {"data": "Nome Annuncio"},
            {"data": "Oggetto"},
            {"data": "Punto ToornaQui"},
            {"data": "Zona Ritiro"},
            {"data": "Indirizzo proprietario annuncio"},
            {"data": "Beneficiario"},
            {"data": "Stato Transazione"},
            {"data": "Data Annuncio"},
            {"data": "Azioni"}
        ],
        "oLanguage": commonOLangTabelleAnnunci,
        "aoColumnDefs": [{"bSortable": false, "aTargets": [0, 9]}]
 */

    /**
     * Premndo contemporaneamente sullla tastiera "s" e "v" lancia lo spinner per testarlo su IE
     * @type Boolean|Boolean
     */
    var map = {83: false, 86: false };
    $(document).keydown(function (e) {
        if (e.keyCode in map) {
            map[e.keyCode] = true;
            if (map[83] && map[86]) {
                
                if($('.theme-loading').length){
                    themeSpinner('hide');
                } else {
                    themeSpinner('show');
                }
            }
        }
    }).keyup(function (e) {
        if (e.keyCode in map) {
            map[e.keyCode] = false;
        }
    });




    /**
     * Plugin gallerie http://dimsemenov.com/plugins/magnific-popup/
     */

    /**
     * Galleria annuncio
     */
    $('.image-link').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
    });

    /**
     * Galleria oggetto storico
     */
    $('.gallery-storico').each(function () {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    });


    $('.user-stars-rating').barrating({
        theme: 'css-stars',
        showValues: false,
        showSelectedRating: false
    });



    $("#button").click(function () {
        $('html, body').animate({
            scrollTop: $("#elementtoScrollToID").offset().top
        }, 2000);
    });



    $('.select-rating-profile').barrating({
        theme: 'css-stars'
    });

    $('.select-rating-profile').barrating('readonly', true);


    $("#btn-show-filters").click(function () {
        if ($('#form-ricerca-annuncio').hasClass('in')) {

            $(this).removeClass('active')
        } else {
            $(this).addClass('active')
        }
    });


    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        var newTab = $(e.target).attr("href");

        //ho cambiato tab => reinizializzo tutte le datatable interne alla nuova tab
        $(newTab).find('table.dataTable').each(function () {
            if ($(this).DataTable() != null && $(this).DataTable().responsive != null) {
                $(this).DataTable().responsive.recalc();
            }
        });
    });

    reinizializzaTooltips = function () {
        $(".tooltip-top").tooltip();
    };
    
    //gli input date hanno il datepicker
    $('.input-group.date').datepicker({
        todayHighlight: true,
        autoclose: true,
        weekStart: 1,
        language: "it",
        format: "dd/mm/yyyy"
    });

}); //ready





/**
 * 
 * PAGINA INSERIMENTO ANNUNCI
 * 
 * 
 * 
 */
/**
 * VALIDAZIONE MAIL
 */
function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
}
/**
 * VALIDAZIONE TELEFONO
 */
function isValidPhone(phone) {
    var pattern = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
    return pattern.test(phone);
}

/**
 * VALIDAZIONE CODICE FISCALE
 */
function isValidCodiceFiscale(cf) {
    var pattern = /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/;
    return pattern.test(cf);
}

/**
 * GRAFICA VALIDAZIONE
 */
function rimuovi_stato(campo)
{
    jQuery(campo + '-span').removeClass('glyphicon-remove');
    jQuery(campo + '-span').removeClass('glyphicon-ok');
    jQuery(campo + '-div').removeClass('has-error');
    jQuery(campo + '-div').removeClass('has-success');
    jQuery(campo + '-small').html('');
}
function stato_errore(campo, messaggio)
{
    jQuery(campo + '-span').addClass('glyphicon-remove');
    jQuery(campo + '-div').addClass('has-error');
    jQuery(campo + '-small').html(messaggio);

}
function stato_success(campo)
{
    jQuery(campo + '-div').removeClass('has-error');
    jQuery(campo + '-div').addClass('has-success');
    jQuery(campo + '-span').removeClass('glyphicon-remove');
    jQuery(campo + '-span').addClass('glyphicon-ok');
    jQuery(campo + '-small').html('');

}

// as the page loads, call these scripts

jQuery(document).on('click', '.button-proponi-oggetto', function () {
    window.location.href = wpdm_proponi_oggetti_url + '?id_annuncio=' + this.value;
});
jQuery(document).on('click', '.button-oggetti-proposti-annuncio', function () {
    window.location.href = wpdm_oggetti_proposti_url + '?id_annuncio=' + this.value;
});

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};





